import React from 'react';
import { CPSPrompts } from './blocks';
import { CPSPromptData } from '@/pages/buddy/types/CPSPromptData';

interface CPSPromptsContentProps {
    cpsPrompts: CPSPromptData[];
    loading: boolean;
}

const CPSPromptsContent: React.FC<CPSPromptsContentProps> = ({ cpsPrompts, loading }) => {
    return (
        <div>
            <CPSPrompts cpsPrompts={cpsPrompts} loading={loading} />
        </div>
    );
};

export { CPSPromptsContent };
